import React, { Component } from "react";

class CategorySelector extends Component {
  constructor(props) {
    super(props);
    // Inicializando a variável para armazenar as categorias
    this.state = {
      categories: [],
      selectedCategory: null, // Para armazenar a categoria selecionada
      selectorBG: false,
      scrollTriggeredByUser: false,
    };
  }

  componentDidMount() {
    window.addEventListener(
      "scroll",
      this.handleScroll,
      this.registerScrollEvent()
    );
  }

  componentDidUpdate() {
    if (this.state.selectedCategory) {
      const container = document.querySelector(".category-selector");
      const selectedItem = document.querySelector(".category-text.active");

      if (container && selectedItem) {
        const containerWidth = container.offsetWidth;
        const itemOffsetLeft = selectedItem.offsetLeft;
        const itemWidth = selectedItem.offsetWidth;

        container.scrollLeft =
          itemOffsetLeft - containerWidth / 2 + itemWidth / 2;
      }
    }
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
    // Remove o ouvinte de scroll ao desmontar o componente
    window.removeEventListener(
      "scroll",
      this.handleScroll,
      this.removeScrollEvent()
    );
  }

  registerScrollEvent() {
    window.addEventListener("scroll", this.scrollFunc);
  }

  removeScrollEvent() {
    window.removeEventListener("scroll", this.scrollFunc);
  }

  scrollFunc = () => {
    if (document.documentElement.scrollTop > 180) {
      this.setState({ selectorBG: true });
    }
    if (document.documentElement.scrollTop < 180) {
      this.setState({ selectorBG: false });
    }
  };

  handleScroll = () => {
    if (this.state.scrollTriggeredByUser) return; // Se foi disparado pelo usuário, não atualiza o selectedCategory
    const { items } = this.props.data;
    let selectedCategory = null;

    // Verifica se o scroll foi disparado pelo usuário ou se foi por clique

    Object.keys(items).forEach((category, index) => {
      const categoryBlock = document.getElementById(category + index);

      if (categoryBlock) {
        const rect = categoryBlock.getBoundingClientRect();
        if (rect.top <= window.innerHeight / 2 && rect.bottom >= 0) {
          selectedCategory = category + index;
        }
      }
    });

    this.setState({ selectedCategory });
  };

  handleMenuItemClick = (event) => {
    const categoryName = event.currentTarget.dataset.name;
    const { items } = this.props.data;
    const categories = Object.keys(items);
    const categoryBlock = document.getElementById(categoryName);

    // Verifica a quantidade de produtos na categoria
    const isLastItem =
      categoryName.slice(0, -1) === categories[categories.length - 1];
    const scrollOffset = -110;

    setTimeout(() => {
      categoryBlock.scrollIntoView();
      window.scrollBy(0, isLastItem ? -40 : scrollOffset);
      this.setState({
        selectedCategory: categoryName,
        scrollTriggeredByUser: true,
      });

      // Depois de um tempo, volta a permitir que o handleScroll atualize o selectedCategory
      setTimeout(() => {
        this.setState({ scrollTriggeredByUser: false });
      }, 1000); // Espera 1 segundo ou o tempo necessário para evitar conflitos
    });
  };

  render() {
    const { selectedCategory, selectorBG } = this.state;
    const { merchant } = this.props;
    return (
      <React.Fragment>
        <div className="col-12 p-0 fixed" style={{ zIndex: "9", top: "4rem" }}>
          {selectorBG && merchant && (
            <div
              className="col-12 p-0"
              style={{
                backgroundColor: "white",
                borderBottom: "2px solid #f2f2f2",
              }}
            >
              <div className="p-0">
                <div className="d-flex flex-wrap justify-content-center align-items-center">
                  <div
                    className="category-selector"
                    style={{
                      display: "flex",
                      overflowX: "auto", // Permite rolagem no eixo X
                      whiteSpace: "nowrap",
                      scrollBehavior: "smooth",
                      scrollbarWidth: "none", // Oculta a barra de rolagem no Firefox
                      msOverflowStyle: "none", // Oculta a barra de rolagem no IE/Edge
                    }}
                  >
                    {Object.keys(this.props.data.items).map(
                      (category, index) => {
                        const categoryId = category + index;
                        return (
                          <span
                            key={category}
                            className={`category-text m-2 ${
                              selectedCategory === categoryId ? "active" : ""
                            }`}
                            onClick={this.handleMenuItemClick}
                            data-name={category + index}
                            style={{
                              cursor: "pointer",
                              color:
                                selectedCategory === categoryId
                                  ? "orange"
                                  : "black",
                              fontSize: "16px",
                              padding: "5px 10px",
                              borderBottom:
                                selectedCategory === categoryId
                                  ? "2px solid orange"
                                  : "2px solid transparent",
                              borderTop: "2px solid transparent",
                              textAlign: "center",
                              fontWeight: "bold",
                              margin: "0 5px",
                              transition: "all 0.3s ease",
                            }}
                          >
                            {category}
                          </span>
                        );
                      }
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default CategorySelector;
